module.exports = __webpack_public_path__ + "static/media/ss8.ec8e2ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ss8.png
// module id = 235
// module chunks = 0